import { render } from "./termplanqte.vue?vue&type=template&id=5d3fd6d6&scoped=true"
import script from "./termplanqte.vue?vue&type=script&lang=js"
export * from "./termplanqte.vue?vue&type=script&lang=js"

import "./termplanqte.vue?vue&type=style&index=0&id=5d3fd6d6&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3fd6d6"]])

export default __exports__